<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <span v-if="assformapagto.formapagto && assformapagto.formapagto != null">
                    {{ $t('formapagto') }}: {{ assformapagto.formapagto.descricao }}
                </span>
                <span v-else> {{ $t('formapagto') }}: {{ selected.descricao }} </span>
            </div>
            <div class="header-buttons">
                <button class="save-btn" type="button" @click="save">
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AssFormaPagamentoCliente from '@/services/vendas/cliente/abas/AssFormaPagamentoClienteService';
import Message from '@/models/Message';

export default {

    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssFormaPagamentoCliente(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            assformapagto: {
                idformapagtocliente: null,
                idformapagto: null,
                idcliente: null,
                formapagto: null,
                isVenda: this.$route.meta.contexto == 'vendas',
            },
        };
    },
    created() {
        this.assformapagto.idcliente = this.selected.idcliente;
        this.assformapagto.idformapagto = this.selected.idformapagto;
        if (this.selected.idformapagtocliente != null) {
            this.carregarDados(this.selected.idformapagtocliente);
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.assformapagto = value.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },

        generateId(numberId) {
            return this.$route.name + '-assformapagto-' + numberId;
        },
        save() {
            this.isLoading = true;
            this.saveFP()
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message('error', `${value.message}`, true));
                    } else {
                        this.$root.showMessage(
                            'success',
                            this.assformapagto.idformapagtocliente != null
                                ? 'msg-sucesso-ao-editar-associcao'
                                : 'msg-sucesso-ao-adicionar-associacao'
                        );
                        setTimeout(() => {
                            this.$emit('fecharModal', true);
                        }, 200);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveFP() {
            if (this.isVenda) return this.assService.saveVendas(this.assformapagto);
            else return this.assService.saveAgro(this.assformapagto);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
